namespace SPA {
	export namespace Realtor {
		export class ObjectList extends Backbone.Collection<SPA.Realtor.RealtorObjectModel>
		{
			public constructor(models?: SPA.Realtor.RealtorObjectModel[], options?: any)
			{
				super(models, options);
			}

			public preinitialize(models?: SPA.Realtor.RealtorObjectModel[], options: any = {}): void
			{
				// Not sure if you need that with correct Collection Model extend
				this.model = SPA.Realtor.RealtorObjectModel;
			}
			public initialize(models?: SPA.Realtor.RealtorObjectModel[], options?: any): void {
				this.listenTo(this, 'all', (...args) => console.log(args));
			}

			public fetch(options: Backbone.CollectionFetchOptions = {}): JQueryXHR
			{
				this.url = location.protocol + '//' + Wollmilch.URL + AJAXCallbase_e.REALTOR + 'object/list/' + app.getAuthenticationManager().getPerson() + '/limit/500/page/0';

				options.beforeSend = this.addHeaders;
				return super.fetch(options);
			}

			public modelId(attr: SPA.Realtor.IRealtorObject) {
				return attr.ObjectNumber;
			}

			public parse(response: Wollmilch.ResponseObject, options: any)
			{
				return response.data;
			}

			private addHeaders(xhr: JQuery.jqXHR)
			{
				xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
				xhr.setRequestHeader('GSDWollmilch-API-AuthToken', Wollmilch.AuthToken);
				xhr.setRequestHeader('GSDWollmilch-API-Key', 'API-KEY');
			}
		}
	}
}
